"use client";

import { useState, useCallback, useEffect } from "react";

// v2 may contain single-vial prices captured before the catalog moved to box units.
// A new generation starts from product views that carry the current box price.
const STORAGE_KEY = "peptide-recently-viewed-v3";
const MAX_ITEMS = 10;

export interface RecentlyViewedItem {
	slug: string;
	name: string;
	price: number | null;
	currency: string;
	image: string | null;
	reviewAvg?: number;
	reviewCount?: number;
}

export function useRecentlyViewed() {
	const [items, setItems] = useState<RecentlyViewedItem[]>([]);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		queueMicrotask(() => {
			setMounted(true);
			try {
				const raw = localStorage.getItem(STORAGE_KEY);
				const parsed = raw ? (JSON.parse(raw) as RecentlyViewedItem[]) : [];
				setItems(Array.isArray(parsed) ? parsed : []);
			} catch {
				setItems([]);
			}
		});
	}, []);

	const add = useCallback((item: RecentlyViewedItem) => {
		setItems((prev) => {
			// Remove existing entry for this slug, then prepend
			const filtered = prev.filter((p) => p.slug !== item.slug);
			const next = [item, ...filtered].slice(0, MAX_ITEMS);
			try {
				localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
			} catch {
				// Ignore quota / private mode
			}
			return next;
		});
	}, []);

	return { items, add, mounted };
}
